import Navbar from "../../components/Navbar/Navbar";
import './Error.css'
import err from '../../assets/Error/err.gif';

const Error = () => {
    return (
        <div className="Error">
            <Navbar/>

            <div className="err-cont">
                <div className="err-box">
                    <img src={err} alt="404 Error" className="err" />
                </div>
            </div>
        </div>
    );
}
 
export default Error;